import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
export class AboutRoutesConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}

  state(prefix: string = 'about') {
    this.$stateProvider
      .state(`${prefix}`, {
        url: 'about/',
        template: '<about/>',
        data: {
          pageTitle: 'About'
        },
        resolve: {
          _AuthenticationQueryModel: (loginConfigurationCommand: ICommand, loadAccountCommand: ICommand) =>
            loginConfigurationCommand().then((login_config) => {
              if (!_4.isEmpty(login_config.user_data)) {
                return loadAccountCommand();
              } else {
                return false;
              }
            })
        }
      })
      .state(`${prefix}.default`, {
        url: 'default/',
        template: '<about-home/>',
        data: {
          pageTitle: 'About',
          ignoredInHistory: false
        }
      })
      .state(`${prefix}.config`, {
        url: 'config/',
        template: '<about-config/>',
        data: {
          pageTitle: 'Application Configuration'
        }
      })
      .state(`${prefix}.toggles`, {
        url: 'toggles/',
        template: '<about-toggles/>',
        data: {
          pageTitle: 'Feature Toggles'
        }
      })
      .state(`${prefix}.release`, {
        url: 'release/',
        template: '<about-release/>',
        data: {
          pageTitle: 'Release Information'
        }
      })
      .state(`${prefix}.device`, {
        url: 'device/',
        template: '<about-device/>',
        data: {
          pageTitle: 'Device Information'
        }
      });
  }
  $get() {
    return {
      state: this.state
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/about_routes.ts